const CHECKOUT_TOKEN_COOKIE = "awakeo_checkout_token";
const CHECKOUT_TOKEN_MAX_AGE_SECONDS = 60 * 60 * 3;

const checkoutCookieDomain = (): string => {
  if (typeof window === "undefined") return "";
  const host = window.location.hostname.toLowerCase();
  if (host === "localhost" || host === "127.0.0.1") return "";
  if (host === "awakeo.app" || host.endsWith(".awakeo.app")) return "; Domain=.awakeo.app";
  return "";
};

/** Share completion token with awakeo.app/download after Stripe redirects off the funnel subdomain. */
export const setCheckoutCompletionCookie = (token: string): void => {
  if (typeof document === "undefined" || !token.trim()) return;
  const secure = typeof window !== "undefined" && window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${CHECKOUT_TOKEN_COOKIE}=${encodeURIComponent(token.trim())}; Max-Age=${CHECKOUT_TOKEN_MAX_AGE_SECONDS}; Path=/${checkoutCookieDomain()}; SameSite=Lax${secure}`;
};
